import { ulid } from '../api/ulid';
import { META_KEYS, readMeta, writeMeta, type SmartkeurDatabase } from './db';

/**
 * Client-gegenereerde UUID. Wordt gebruikt als primaire sleutel én als
 * idempotency key, zodat een record offline al zijn definitieve id heeft.
 */
export function newId(): string {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID();
    }

    const bytes = new Uint8Array(16);
    crypto.getRandomValues(bytes);
    bytes[6] = ((bytes[6] ?? 0) & 0x0f) | 0x40;
    bytes[8] = ((bytes[8] ?? 0) & 0x3f) | 0x80;

    const hex = [...bytes].map((byte) => byte.toString(16).padStart(2, '0')).join('');

    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

/**
 * Elke identiteit die over de draad gaat - `op_uuid`, `batch_uuid`,
 * `answer_uuid`, `finding_uuid` en de `client_uuid` van een foto - is een ULID:
 * de API bewaart ze in `ulid`-kolommen en weigert een andere vorm. De volgorde
 * van de outbox staat los hiervan (`seq`).
 */
export function newUlid(now: number = Date.now()): string {
    return ulid(now);
}

/**
 * Stabiele identificatie van dit apparaat. De server gebruikt hem om te zien
 * welk apparaat een mutatie stuurde; wij gebruiken hem bij conflicten.
 */
export async function getDeviceId(db: SmartkeurDatabase): Promise<string> {
    const existing = await readMeta<string>(db, META_KEYS.deviceId);

    if (existing) {
        return existing;
    }

    const deviceId = newId();
    await writeMeta(db, META_KEYS.deviceId, deviceId);

    return deviceId;
}
